import Markdown from 'markdown-to-jsx';

interface Props {
  content: string;
}

const MarkdownViewer: React.FC<Props> = ({ content }) => (
  <>
    <div className='markdown-container select-text'>
      <Markdown>{content}</Markdown>
    </div>
    <style jsx>{`
      .markdown-container :global(ol),
      .markdown-container :global(ul) {
        list-style-type: revert;
        list-style-position: inside;
        padding-left: 1rem;
      }
      .markdown-container :global(blockquote) {
        @apply pl-2 border-l-2 border-gray-600;
      }
    `}</style>
  </>
);

export default MarkdownViewer;
